import React from 'react';

const Privacy  = () => {
    return (
        <>
            <div className="container">
                <br />
                <h3 className="text-center">Warranty  Terms </h3>
                <br />
                <p>
                    This Warranty  Terms  relates solely to the information collection and use practices of our web site located at www.Mattress Compay Name.com. We recognize that many visitors and users of this Website are concerned about the information they provide to us, and how we treat that information. This Warranty  Terms , which may be updated from time to time, has been developed to address those concerns.
                </p>
                <p>
                    By accessing or using our website or by providing your information, you hereby acknowledge that you have read, understood, and agree to be bound by all the terms of this Warranty  Terms  and our website terms of use. If you do not agree to these terms, please exit this page and do not access or use the website.
                </p>
                <p>
                    1. <strong>Changes to Warranty  Terms :</strong> We review our Warranty  Terms  from time to time, and we may make periodic changes to the Terms  in connection with that review...
                </p>
                <p>
                    2. <strong>Information Collected and Uses of Collected Information:</strong> We collect the information about our Website Users, i.e., Personal Identification Information.
                </p>
                <p>
                    3. <strong>Personal Identification Information:</strong> Personal Identification Information is information that identifies a specific End User...
                </p>
                <p>
                    We use Personal Identification Information to provide products to you, enhance the operation of the Website, improve our marketing and promotional efforts...
                </p>
                <p>
                    4. <strong>Release of Personal Identification Information:</strong> We will not sell, trade, rent or share your Personal Identification Information with other parties...
                </p>
                <p>
                    5. <strong>Updating Information:</strong> You will have the ability to access and edit the Personal Identification Information you provide us...
                </p>
                <p>
                    6. <strong>Data Tracking:</strong> “Cookies” are small pieces of information that are stored by your browser on your computer’s hard drive...
                </p>
                <p>
                    7. <strong>Security of Information:</strong> We take appropriate precautions to protect the security of Personal Identification Information...
                </p>
                <p>
                    8. <strong>Warranty  Policies of Third-Party Websites:</strong> This Warranty  Terms  only addresses the use and disclosure of information we collect from you...
                </p>
                <p>
                    9. <strong>Advertising:</strong> Ads appearing on our site may be delivered to Users by advertising partners, who may set cookies...
                </p>
                <p>
                    10. <strong>Google Ad sense:</strong> Some of the ads may be served by Google. Google’s use of the DART cookie enables it to serve ads...
                </p>
                <p>
                    11. <strong>Miscellaneous Warranty  Issues Children:</strong> Minors under the age of 18 are not supposed to use the Website...
                </p>
                <p>
                    12. <strong>Public Areas:</strong> We may provide areas on our website where you can publicly post information about yourself...
                </p>
            </div>
        </>
    );
};

export default Privacy ;
